var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDribbleAngleSCurve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-dribbles-arrow-angle-w-s-curve_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-dribbles-arrow-angle-w-s-curve_1",
    "data-name": "Icon-dribbles-arrow-angle-w-s-curve \\u2013 1",
    clipPath: "url(#clip-Icon-dribbles-arrow-angle-w-s-curve_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-dribbles-arrow-angle-w-s-curve",
    transform: "translate(8787.797 -10692.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M3184.52-13415.67l-3.414-2.094-2.434-3.588-1.5,4.038-3.438-1.677v4.861l-3.247-1.541-3.274,1.541.68-3.971-3.187-.891",
    transform: "translate(-11950.682 24118.92)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-play-arrow",
    "data-name": "Icon material-play-arrow",
    d: "M12,7.5l1.109,5.48L12,18.46l8.611-5.48Z",
    transform: "translate(-8774.308 10684.734) rotate(25)",
    fill: "#707070"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbleAngleSCurve);
export default __webpack_public_path__ + "static/media/dribble-angle-s-curve.63fce7bbb4543bf32c2d9565f98353f0.svg";
export { ForwardRef as ReactComponent };